export const SET_REVIEWS_LOADER = 'SET_REVIEWS_LOADER';
export const GET_REVIEWS = "GET_REVIEWS";
export const SET_REVIEWS = "SET_REVIEWS";
export const UPDATE_REVIEW = 'UPDATE_REVIEW';
export const SET_UPDATE_REVIEW = 'SET_UPDATE_REVIEW';
export const GET_REVIEWS_DUMP = 'GET_REVIEWS_DUMP';
export const SET_REVIEWS_DUMP = 'SET_REVIEWS_DUMP';
export const UPLOAD_REVIEWS_FILE = 'UPLOAD_REVIEWS_FILE';
export const RESET = 'RESET';
export const GENERATE_PRESIGNED_URL = 'GENERATE_PRESIGNED_URL';